/*
 * Footer newsletter signup without a page reload.
 *
 * Shopify's customer form normally reloads the page, and the message it renders
 * sits in the footer, which is out of view at the top of the reloaded page. Here
 * the form posts in the background and the success (or error) message from the
 * snippet is shown in place.
 *
 * Shopify protects this form with invisible hCaptcha. When its script binds to
 * the form (on first focus) it keeps the form's own submit() and calls it once
 * the visitor passes the check. So submit() is replaced here, before that bind,
 * with the background post: hCaptcha runs first, adds its token, then hands
 * over to us. Forms without hCaptcha are caught by the submit listener instead.
 *
 * Anything unexpected — Shopify's challenge page, a network error, an unreadable
 * response — falls back to the normal submit, so a signup is never lost.
 */
(function () {
  if (window.__newsletterFormBound) return;
  window.__newsletterFormBound = true;
  if (!window.fetch || !window.FormData || !window.DOMParser) return;

  var nativeSubmit = HTMLFormElement.prototype.submit;

  function send(form) {
    if (form.hasAttribute('data-submitting')) return;
    form.setAttribute('data-submitting', '');

    var success = form.querySelector('[data-newsletter-success]');
    var error = form.querySelector('[data-newsletter-error]');
    var input = form.querySelector('input[type="email"]');
    var button = form.querySelector('[type="submit"]');
    if (button) button.disabled = true;
    if (error) error.hidden = true;

    function done() {
      form.removeAttribute('data-submitting');
      if (button) button.disabled = false;
    }

    function fallback() {
      done();
      nativeSubmit.call(form);
    }

    fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
      .then(function (res) {
        // A good signup redirects to ?customer_posted=true.
        if (/[?&]customer_posted=true/.test(res.url)) {
          if (success) success.hidden = false;
          if (input) {
            input.value = '';
            input.removeAttribute('aria-invalid');
          }
          done();
          return;
        }

        // Shopify's challenge page needs the real page.
        if (!res.ok || /\/challenge/.test(res.url)) {
          fallback();
          return;
        }

        return res.text().then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = form.id && doc.getElementById(form.id);
          var freshError = fresh && fresh.querySelector('[data-newsletter-error]');
          var message = freshError && freshError.textContent.trim();
          if (!message || !error) {
            fallback();
            return;
          }
          if (success) success.hidden = true;
          error.textContent = message;
          error.hidden = false;
          if (input) input.setAttribute('aria-invalid', 'true');
          done();
        });
      })
      .catch(fallback);
  }

  function bind(form) {
    if (form.__newsletterBound) return;
    form.__newsletterBound = true;
    try {
      form.submit = function () {
        send(form);
      };
    } catch (err) {
      /* leave the native submit in place */
    }
  }

  function bindAll() {
    document.querySelectorAll('form.newsletter-form').forEach(bind);
  }

  bindAll();
  document.addEventListener('DOMContentLoaded', bindAll);

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form.newsletter-form');
    if (!form) return;
    // Cancelled by Shopify's captcha script: it calls form.submit() — the
    // background post above — once the visitor passes.
    if (e.defaultPrevented) return;
    e.preventDefault();
    send(form);
  });
})();
